// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__23Pou","savePackageButton":"ClientWallet_savePackageButton__XAPQr"};